module.exports = __webpack_public_path__ + "img/world.4c89586c.png";